import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/conversations/$conversationId/thread/$threadId`
// activates the reply-thread column (col 3). The Conversations LAYOUT route
// (conversations.tsx) reads `$threadId` off the leaf match and renders the
// ThreadPanel via ColumnLayout. Mirrors forms/$formId/$responseId.
export const Route = createFileRoute(
  "/$orgSlug/$eventSlug/conversations/$conversationId/thread/$threadId",
)({
  component: () => null,
})
